<template lang="pug">
  .container.grid-lg
    page-title(title="Indicar produtos" icon="fas fa-bullhorn" subtitle="Indique produtos na DentalGO e receba por isso")
      div(slot="actions")
        router-link.btn.btn-action.btn-link.text-error.tooltip.tooltip-left(:to="{ name: 'help.filiations.link', query: { ref: 'indications' } }" data-tooltip="Ajuda")
          i.fas.fa-question
        router-link.btn.btn-link.tooltip.tooltip-left.mr-2(
          :to="{ name: 'indications.list.filter', query: $route.query }"
          data-tooltip="Filtrar"
        )
          i.fas.fa-filter
          span.badge(v-if="Boolean($route.query.q)")
    list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
      .columns(v-if="list && list.rows.length > 0")
        .column.col-6.col-sm-12.mb-2.pb-2(v-for="row in list.rows" :key="row.id")
          row(:product="row")
    router-view
</template>

<script>
import listMixin from '@/mixins/list'
import products from '@/services/api/products'
import Row from './Row'

export default {
  mixins: [listMixin],
  components: { Row },
  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await products.list(params)
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
